import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/header.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/server-info.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/footer.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
